import React from 'react';
import { Typography } from 'fronton-react';
import { subtitleText, subtitleTopLineContainer, subtitleWrapper } from './styles';

interface CarouselSubtitleProps {
  subtitle?: string;
}

export const CarouselSubtitle = ({ subtitle }: CarouselSubtitleProps) => {
  return (
    <div className={subtitleTopLineContainer}>
      <div className={subtitleWrapper}>
        <Typography
          data-qa="sponsored-carousel-subtitle"
          className={subtitleText}
          size="accent"
          variant="mini"
        >
          {subtitle}
        </Typography>
      </div>
    </div>
  );
};
